/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Groups_DescriptionInputs */



/**
* | output |
* | --- |
* | "Set up a closed circle of friends to share wishlists and tradelists, pool cards into shared collections, and see who has what you want." |
*
* @param {Help_Article_Groups_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_groups_description = /** @type {((inputs?: Help_Article_Groups_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Groups_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Richte einen geschlossenen Freundeskreis ein, um Wunsch- und Tauschlisten zu teilen, Karten in gemeinsamen Sammlungen zu bündeln und zu sehen, wer hat, was du suchst.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez un cercle fermé d'amis pour partager listes de souhaits et listes d'échange, regrouper des cartes dans des collections communes et voir qui possède ce que vous cherchez.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("建立一个只有朋友的封闭圈子，共享心愿单和交换清单，把卡牌汇入共享收藏，并看到谁有你想要的卡牌。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("建立一個朋友間的封閉圈子，分享願望清單與交換清單、把卡牌集中成共用收藏，並看看誰有你想要的卡牌。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("친구들만의 닫힌 모임을 만들어 위시리스트와 교환 목록을 공유하고, 카드를 공동 컬렉션에 모으고, 원하는 카드를 누가 가졌는지 확인하세요.")
	return /** @type {LocalizedString} */ ("Set up a closed circle of friends to share wishlists and tradelists, pool cards into shared collections, and see who has what you want.")
});